<template>
<z-message-box size='confirm' @close="close" :show='shows' :noClose="noCloseTag" :title="titleTig">
    <p class="z-confirm-p">{{ message }}</p>
    <div class="z-confirm-btn">
      <z-button size='icon-query' @click='yes()'>{{ okText || '确定' }}</z-button>
      <z-button v-if="closeText" @click='close'>{{ closeText }}</z-button>
    </div>
</z-message-box>
</template>
<script type="text/babel">
/* eslint-disable */
import ZButton from "../zButton";
import ZMessageBox from "../message-box";
export default {
  name: "confirm",

  components: {
    ZButton,
    ZMessageBox
  },
  props: {
    shows: Boolean,
    message: "",
    titleTig: "",
    closeText: '',
    okText: '',
    noCloseTag: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$emit("confirmok", false);
    },
    yes() {
      this.$emit("confirmok", true);
    }
  }
};
</script>

<style>
.z-confirm-p {
  font-size: 12px;
  margin: 10px 20px;
  padding: 10px 0;
  white-space: normal;
  color: #666;
  text-align: justify;
  line-height: 22px;
}
.z-confirm-btn {
  text-align: center;
}
.z-confirm-btn button {
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
